var map = {
	"./en.json": [
		"./resources/lang/en.json",
		"resources_lang_en_json"
	],
	"./id.json": [
		"./resources/lang/id.json",
		"resources_lang_id_json"
	],
	"./php_en.json": [
		"./resources/lang/php_en.json",
		"resources_lang_php_en_json"
	],
	"./php_id.json": [
		"./resources/lang/php_id.json",
		"resources_lang_php_id_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./resources/lang lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;